export const PAYMENT = "payment";
export const INVOICE = "invoice";
export const BILLING = "billing";
export const COLLECTION = "collection";
export const CLEARING = "clearing";
export const GL = "generalLedger";
export const AUDIT_TRAIL = "auditTrail";
export const COST = "costAnalytics";
export const BALANCE = "balanceReports";